(function (window, document) {
  window.componentEvents.on('consumer-rx-form-instantiate', init);

  /**
   * Instantiate consumer-rx navigation interactions.
   */
  function init(form) {
    const steps = Array.from(form.querySelectorAll('[data-rx-step]'));
    const next = form.querySelector('[data-rx-step-nav="next"]');
    const submit = form.querySelector('button[type="submit"]');

    form.dataset.rxActiveStep = 1;
    form.dataset.rxTotalSteps = steps.length;
    prepareSteps();
    hideSubmitButton();
    updateNavigationalButtons(1);
    updateFocusability(1);
    // Handle presses on “Next” button.
    next.addEventListener('click', advanceForm);
    createProgressIndicator();
    // Mark the form as instantiated.
    form.dataset.rxFormInstantiated = true;

    window.componentEvents.on(`rx-form-update-submit-button-${form.id}`, updateSubmitButton);
    window.componentEvents.on(`rx-form-reset-${form.id}`, () => advanceForm(1));

    /**
     * Find all steps in the markup and prep them for interaction.
     */
    function prepareSteps() {
      steps.forEach((step, index) => step.dataset.rxStep = index + 1);
    }

    /**
     * Create a progress indicator with dynamic navigation buttons.
     */
    function createProgressIndicator() {
      const buttons = steps.map((step) => {
        const button = document.createElement('BUTTON');
        button.classList.add('consumer-rx__progress-indicator-button');
        button.dataset.rxStepNav = step.dataset.rxStep;
        button.innerText = `Go to Step ${button.dataset.rxStepNav}`;
        button.type = 'button';
        button.addEventListener('click', advanceForm);
        return button;
      });
      const nav = document.createElement('NAV');
      nav.classList.add('consumer-rx__progress-indicator');
      const list = document.createElement('UL');
      list.classList.add('consumer-rx__progress-indicator-list');
      buttons.forEach((button) => {
        const item = document.createElement('LI');
        item.classList.add('consumer-rx__progress-indicator-item');
        item.appendChild(button);
        list.appendChild(item);
      });
      nav.appendChild(list);
      form.insertBefore(nav, form.children[0]);
    }

    /**
     * Advance the Rx form to the next step, or an arbitrary step.
     *
     * @param event The event that triggered this handler.
     */
    function advanceForm(data) {
      const active = determineStep(data);
      form.dataset.rxActiveStep = active;
      scrollFormToTop();
      updateNavigationalButtons(active);
      updateFocusability(active);
      updateSubmitButton(active);
      // Emit event to signal to other components that navigation occurred.
      window.componentEvents
        .emitEvent(`rx-form-nav-${form.id}`, [{ activeStepNumber: active }]);
    }

    /**
     * Determine the step to which the form should be advanced.
     *
     * @param data An object from which the step can be determined. It may
     * be an event object (from when a button is clicked) or a generic
     * object (from when a custom event is fired).
     *
     * @returns step An integer representing the step to which the form
     * should be advanced.
     */
    function determineStep(data) {
      let step;
      if (data.target) {
        // If the object has a `target` property, treat it as an event.
        const button = data.target;
        switch (button.dataset.rxStepNav) {
          case 'next':
            step = parseInt(form.dataset.rxActiveStep) + 1;
            break;
          default:
            step = parseInt(button.dataset.rxStepNav);
        }
      } else {
        // Otherwise, treat the data as an integer.
        step = data;
      }
      return step;
    }

    /**
     * Scroll to the top of the Consumer Rx form.
     */
    function scrollFormToTop() {
      // Try to scroll the modern way, otherwise use the less-than-ideal way.
      if (typeof form.scrollTo === 'function') {
        form.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        form.scrollTop = 0;
      }
    }

    /**
     * Update state of navigational buttons.
     */
    function updateNavigationalButtons(active) {
      form.querySelectorAll(`[data-rx-step-nav]:not([data-rx-step-nav="next"])`)
        .forEach(button => {
          button.setAttribute('aria-selected', parseInt(button.dataset.rxStepNav) === active);
        });
    }

    /**
     * Update focusability of all steps.
     */
    function updateFocusability(active) {
      // Make active step focusable.
      form.querySelectorAll(`[data-rx-step="${active}"]`)
        .forEach((step) => updateFocusabilityOfSingleStep(step, true));
      // Make inactive steps not focusable.
      form.querySelectorAll(`[data-rx-step]:not([data-rx-step="${active}"])`)
        .forEach((step) => updateFocusabilityOfSingleStep(step, false));
    }

    /**
     * Update focusability of form controls within a given step.
     */
    function updateFocusabilityOfSingleStep(step, visible) {
      const focusableElements = step.querySelectorAll([
        'a[href]:not([inert])',
        'area[href]:not([inert])',
        'input:not([inert])',
        'select:not([inert])',
        'textarea:not([inert])',
        'button:not([inert])',
        'iframe:not([inert])',
        'audio:not([inert])',
        'video:not([inert])',
        '[contenteditable]:not([inert])',
        '[tabindex]:not([inert])'
      ]);
      focusableElements.forEach((element) => {
        visible ? element.removeAttribute('tabindex') :
          element.setAttribute('tabindex', -1);
      });
      visible ? step.removeAttribute('aria-hidden') :
        step.setAttribute('aria-hidden', true);
    }

    /**
     * Determine whether the submit button should be shown or hidden and toggle
     * the button accordingly.
     */
    function updateSubmitButton(active) {
      active = active || parseInt(form.dataset.rxActiveStep);
      // Steps 2 through last may be marked as skipped, so filter them out before
      // determining the total length of steps.
      const length = steps.filter((step) => step.dataset.rxSkipStep !== 'true').length;
      // Update visibility of next/submit buttons.
      active === length ? showSubmitButton() : hideSubmitButton();
    }

    /**
     * Show the submit button and hide the next button.
     */
    function showSubmitButton() {
      next.setAttribute('aria-hidden', true);
      submit.setAttribute('aria-hidden', false);
    }

    /**
     * Show the next button and hide the submit button.
     */
    function hideSubmitButton() {
      next.setAttribute('aria-hidden', false);
      submit.setAttribute('aria-hidden', true);
    }
  }
})(window, document);
